import firebase from '../../firebase.js';
export default {
    name: 'Manage',
    data: () => {
        return {
            selected: 'comments',
            email: '',
            password: '',
            signInDialog: false,
            signedIn: false,
            authMessageSnackbar: false,
            authMessage: ''
        };
    },
    methods: {
        signIn() {
            firebase
                .auth()
                .signInWithEmailAndPassword(this.email, this.password)
                .then(
                    function() {
                        this.email = '';
                        this.password = '';
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.authMessage =
                            'There was an error signing in. Please try again.';
                        this.authMessageSnackbar = true;
                        console.error('Error signing in: ' + error);
                    }.bind(this)
                );
        },
        signOut() {
            firebase.auth().signOut();
        }
    },
    watch: {
        signedIn(val) {
            if (val == true) {
                this.signInDialog = false;
            }
        }
    },
    created() {
        firebase.auth().onAuthStateChanged(
            function(user) {
                if (user) {
                    this.signedIn = true;
                    this.authMessage = 'Signed in as Admin';
                    this.authMessageSnackbar = true;
                    this.$store.commit('signIn');
                } else {
                    this.signedIn = false;
                    this.$store.commit('signOut');
                }
            }.bind(this)
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/manage/manage.js